import MySecuritySettings from "./MySecuritySettings";

export default MySecuritySettings;